/**
 * Which Clerk instance the app signs users in against.
 *
 * Clerk keeps its development and production instances wholly apart: separate
 * user directories, separate signing keys, separate session tokens. The backend
 * verifies the token it is handed against exactly one of them, so the Clerk
 * instance is not a choice of its own - it follows the backend the bundle was
 * built for. Staging goes with the development instance, production with the
 * live one, and `npm run build:production` picks the pair in one go.
 *
 * Publishable keys are public by design - every browser that loads the app
 * reads this one straight out of the JS bundle - so they live in source, next
 * to the API hosts they travel with, rather than in a secret. The key that must
 * stay secret is Clerk's *secret* key, which belongs to the backend and never
 * appears here.
 *
 * `REACT_APP_CLERK_PUBLISHABLE_KEY` overrides the pair, for pointing a local
 * build at a Clerk instance of your own without editing the map.
 */

import { API_ENVIRONMENT } from "../api";
// Same shape and the same two names as `api/environments.json`, so the key and
// the host a build uses are looked up under one word: `staging` or
// `production`.
import PUBLISHABLE_KEYS from "./publishableKeys.json";

/** Empty when the environment has no key configured yet; `App` checks for that
 *  and says so on screen rather than letting Clerk fail on its own terms. */
export const CLERK_PUBLISHABLE_KEY: string = (
  process.env.REACT_APP_CLERK_PUBLISHABLE_KEY?.trim() ||
  PUBLISHABLE_KEYS[API_ENVIRONMENT] ||
  ""
).trim();
